import { Inject, Injectable } from '@angular/core';
import { AJSFlightsPassengersUtilsServiceToken, FlightsPassengersUtilsServiceType } from '../../../../components/services/Utils/bridges/ib-flights-passengers-utils-bridge.service';
import { AJSUtilstServiceToken, UtilsServiceType } from '@src/components/services/Utils/bridges/ib-utils-bridge.service';
import { CommonsSessionStorageService } from 'ib-web-commons/utils';
import { AcceptObjectsPolicyServiceType, AJSAcceptObjectsPolicyServiceToken } from '@src/app/shared/http-services/pacc-pacc/bridges/ib-accept-objects-bridge.service';
import { AJSGetCKICachedInformationServiceToken } from '@src/app/shared/services/ib-apis/ib-get-cached-information-service-bridge.service';
import { GetCKICachedInformationServiceType } from '@src/app/shared/http-services/pac-prm/bridges/ib-get-cached-information-bridge.service';
import { AJSCheckAncillariesServiceToken, CheckAncillariesServiceType } from '@src/app/shared/services/bridges/ib-check-ancillaries-bridge.service';
import { AJSCheckPaymentsServiceToken, CheckPaymentsServiceType } from '@src/components/services/Utils/bridges/ib-check-payments-bridge.service';
import { CheckinAppConstants } from '@src/components/routing/ib-check-in-constants';
import { CkiDatalayerConstants } from '@src/app/shared/services/ib-datalayer/ib-cki-datalayer-constants';
import {
    AJSFlightsPassengersServiceToken,
    FlightsPassengersServiceType
} from '@src/components/ib-check-in-flights-passengers/services/bridges/ib-flights-and-passengers-bridge.service';
import { CheckinRedirectionService } from '@src/app/shared/services/ib-utils/ib-checkin-redirection.service';
import { AJSCommonsAncillariesServiceToken, CommonsAncillariesServiceType } from '@src/components/services/Utils/bridges/ib-common-ancillaries-bridge.service';
import { AJSModalService, AJSModalServiceType } from '@src/app/shared/services/ib-modal/ib-modal-service-bridge.service';

@Injectable({ providedIn: 'root' })
export class AcceptService {
    constructor (
        @Inject(AJSFlightsPassengersUtilsServiceToken) private FlightsPassengersUtils: FlightsPassengersUtilsServiceType,
        @Inject(AJSUtilstServiceToken) private UtilsService: UtilsServiceType,
        @Inject(AJSAcceptObjectsPolicyServiceToken) private AcceptObjectsPolicyService: AcceptObjectsPolicyServiceType,
        @Inject(AJSModalService) private ModalService: AJSModalServiceType,
        @Inject(AJSGetCKICachedInformationServiceToken) private GetCKICachedInformationService: GetCKICachedInformationServiceType,
        @Inject(AJSCheckAncillariesServiceToken) private CheckAncillariesService: CheckAncillariesServiceType,
        @Inject(AJSCheckPaymentsServiceToken) private CheckPaymentsService: CheckPaymentsServiceType,
        @Inject(AJSFlightsPassengersServiceToken) private FlightsPassengersService: FlightsPassengersServiceType,
        @Inject(AJSCommonsAncillariesServiceToken) private CommonsAncillariesService: CommonsAncillariesServiceType,
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private CheckinRedirectionService: CheckinRedirectionService
    ) {}

    /**
     * @function
     * @name callAccept
     * @desc calls accepted forbidden objects policy and continue to the next step
     */
    callAccept = (passengers, printBoardingCard, nextStep, isEarly): any => {
        const requestAcceptInfo = this.FlightsPassengersUtils.getAcceptUpdateInformation(this.CommonsSessionStorageService.get('availableSegments'), passengers);
        let modalObject;

        const acceptPolicyError = (error) => {
            this.ModalService.finishWaiting();

            const updateCachedData = () => {
                const goToIbcoac = () => {
                    if (this.CheckinRedirectionService.path() === '/ibcoac') {
                        this.CheckinRedirectionService.reload();
                    } else {
                        this.CheckinRedirectionService.path('/ibcoac');
                    }
                };

                if (error.internalErrorCode !== 'IB_00002') {
                    this.GetCKICachedInformationService.getCachedInformation().then(
                        (data) => {
                            this.CommonsSessionStorageService.set('bookingInfo', data);
                            goToIbcoac();
                        },
                        function (error) {
                            goToIbcoac();
                        }
                    );
                }
            };

            this.ModalService.showGenericError(error, false, null).result.then(updateCachedData, updateCachedData);
        };

        const acceptPolicySuccess = (acceptInfo) => {
            const uncheckableSegments = this.UtilsService.updateCachedInfo(acceptInfo.data.acceptedSegments);
            let acceptedSegments = acceptInfo?.data?.acceptedSegments || [];

            const checkAcceptSeats = () => {
                let seatsAssigned = true;
                acceptedSegments.forEach((segment) => {
                    segment.passengers.forEach((passenger) => {
                        if (passenger.seat === null) seatsAssigned = false;
                    });
                });
                return seatsAssigned;
            };

            const acceptSegmentsError = () => {
                if (acceptedSegments.length > 0) {
                    checkAcceptResponse();
                } else {
                    this.UtilsService.goIbCose();
                }
            };

            const checkAcceptResponse = () => {
                this.ModalService.isWaiting();
                if ((acceptInfo.code === 201 || acceptInfo.code === 200) && acceptInfo.data.locator != null) {
                    this.GetCKICachedInformationService.getCachedInformation().then(
                        (cachedData: any) => {
                            const cachedDataPassengers: any = cachedData?.passengers;
                            this.CommonsSessionStorageService.set('bookingInfo', cachedData);
                            this.CommonsSessionStorageService.set(
                                'passengersSelected',
                                this.FlightsPassengersUtils.updateSelectedPassengers(this.CommonsSessionStorageService.get('passengersSelected'), cachedDataPassengers)
                            );
                            this.ModalService.isNotWaiting();
                            this.ModalService.openSplitModal('md', 'modal-split', false, acceptInfo.data.locator).result.then(startCheckinFromSplit, startCheckinFromSplit);
                        },
                        (error) => {
                            this.ModalService.showGenericError(error, false, null);
                        }
                    );
                } else {
                    this.nextViewAfterAccept(printBoardingCard, nextStep, acceptInfo);
                }

                const startCheckinFromSplit = (response) => {
                    this.CheckinRedirectionService.path('/ibcose').search({ surname: this.CommonsSessionStorageService.get('checkinSurname'), pnr: response.data.locator });
                };
            };

            const seatsAssigned = checkAcceptSeats();

            this.ModalService.isNotWaiting();
            if (uncheckableSegments.length > 0) {
                acceptedSegments = this.FlightsPassengersUtils.updateSelectedSegments(this.CommonsSessionStorageService.get('availableSegments'), uncheckableSegments);
                this.CommonsSessionStorageService.set('availableSegments', acceptedSegments);
                this.ModalService.showGenericError(
                    { message: 'NOT_ACCEPTED_SEGMENT_ERROR', needsTranslate: true, idModal: CkiDatalayerConstants.DATALAYER_MODAL_ID.NOT_ACCEPTED_SEGMENT_ERROR },
                    true,
                    'apis.error-modal.html'
                ).result.then(acceptSegmentsError, acceptSegmentsError);
            } else if (isEarly) {
                this.FlightsPassengersService.checkAvailabilitySeatsPassengers().then(
                    (response) => {
                        if (response || seatsAssigned) {
                            this.ModalService.isNotWaiting();
                            checkAcceptResponse();
                        } else {
                            this.seatNotAvailableError();
                        }
                    },
                    (error) => {
                        this.ModalService.showGenericError(error, true, null).result.then(this.UtilsService.goIbCose, this.UtilsService.goIbCose);
                    }
                );
            } else {
                checkAcceptResponse();
            }
        };

        this.AcceptObjectsPolicyService.acceptForbiddenObjectsPolicy(requestAcceptInfo).then(acceptPolicySuccess, acceptPolicyError);
    };

    public nextViewAfterAccept = (printBoardingCard, nextStep, response) => {
        const bkiInfo: any = this.CommonsSessionStorageService.get('bookingInfo');
        if (bkiInfo?.ancillariesDisabled) this.CheckinRedirectionService.path('/ibecbp');
        else if (response.code === 202) {
            this.ModalService.showGenericModal({ message: '{{\'ALERT_NO_SHOW_FEES\'|translate}}' }, true, 'generic-info-modal').result.then(
                () => {
                    this.checkAncillaries(printBoardingCard, nextStep, response.data);
                },
                () => {
                    this.checkAncillaries(printBoardingCard, nextStep, response.data);
                }
            );
        } else {
            this.checkAncillaries(printBoardingCard, nextStep, response.data);
        }
    };

    /**
     * Redirect user to payments or boarding-document depending if have
     * pending payments
     */
    public serviceError = (pendingPayments: boolean = false) => {
        this.ModalService.isNotWaiting();
        if (pendingPayments) {
            this.CheckinRedirectionService.path('/ibpurc');
        } else {
            this.CheckinRedirectionService.path('/ibecbp');
        }
    };

    /**
     * Call ancillaries service
     * @param {BOOL} printBoardingCard
     * @param {String} nextStep Next step in flow
     * @param {Object} responseData
     */
    public checkAncillaries = (printBoardingCard, nextStep, responseData) => {
        const pendingPayments = this.CommonsSessionStorageService.get('pendingPayments'),
            pnr: any = this.CommonsSessionStorageService.get('PNR');
        const isEarly = this.CommonsSessionStorageService.get('isEarly');
        this.CommonsSessionStorageService.set('acceptInfoSegments', responseData);

        const CommonsAncillariesServiceSucces = (ancillariesSummary) => {
            this.UtilsService.setAncillariesCurrency(ancillariesSummary.currencies, ancillariesSummary.context.issueCurrency);
            this.UtilsService.setAncillariesBob(ancillariesSummary.freeItems);
            this.CheckAncillariesService.checkAncillaries().then(() => continueFlow(ancillariesSummary), this.serviceError);
        };

        const CommonsAncillariesServiceError = (response) => {
            const acceptInfo: any = this.CommonsSessionStorageService.get('acceptInfoSegments');
            let uncheckableSegments = false;
            acceptInfo.acceptedSegments.forEach((segments) => {
                segments.passengers.forEach((pax) => {
                    if (pax.status === 'CHECKED' && pax.seat === null && pax.purchaseSeatRequired) {
                        uncheckableSegments = true;
                    }
                });
            });

            if (uncheckableSegments) {
                this.ModalService.showGenericError({ message: 'REST_SERVICE_ERROR_GENERAL', needsTranslate: true }, true, null).result.then(
                    () => {
                        this.UtilsService.goIbCose();
                    },
                    () => {
                        this.UtilsService.goIbCose();
                    }
                );
            } else {
                this.serviceError();
            }
        };

        const continueFlow = (ancillariesSummary) => {
            if (nextStep === CheckinAppConstants.SHUTTLE_NEXT_STEPS.SEATS_MAP) {
                this.CommonsSessionStorageService.set('seatMapSegment', {
                    segmentId: Number(this.CommonsSessionStorageService.get('availableSegments')[0]),
                    pasId: this.CommonsSessionStorageService.get('passengersSelected')[0]
                });
                if (
                    ancillariesSummary &&
                    ancillariesSummary.context &&
                    ancillariesSummary.context.segments.length > 0 &&
                    ancillariesSummary.context.segments[0].passengerCoupons[0].status.code === CheckinAppConstants.FLIGHT_PASSENGERS_STATUS.STANDBY
                ) {
                    this.CommonsSessionStorageService.set('isPaFlow', false);
                } else {
                    this.CommonsSessionStorageService.set('isPaFlow', true);
                }

                this.CheckinRedirectionService.path('/ckianc');
            } else {
                this.ModalService.isNotWaiting();
                this.CheckinRedirectionService.path('/ckianc');
            }
        };
        if (printBoardingCard) {
            if (pendingPayments) {
                this.CheckPaymentsService.checkPayments();
            } else {
                this.CommonsAncillariesService.getAncillarieSummary(undefined, null, pnr).then(
                    (ancillariesSummary) => {
                        this.CommonsSessionStorageService.set('summaryInfo', ancillariesSummary);
                        this.CheckinRedirectionService.path('/ibecbp');
                    },
                    this.serviceError
                    /*
                     * Code commented out due to the recurring HTTP 500 response from the ancillaries-summary service.
                     * JIRA Task: DIB-9322
                     *
                     * () => {
                     *     this.ModalService.showGenericError({ message: 'REST_SERVICE_ERROR_GENERAL', needsTranslate: true }, true).result.then(() => {
                     *         UtilsService.goIbCose();
                     *     }, () => {
                     *         UtilsService.goIbCose();
                     *     });
                     * }
                     */
                );
            }
        } else if (responseData && responseData.upgrading) {
            this.CommonsSessionStorageService.set('upgradeInfo', responseData.upgrading);
            this.CheckinRedirectionService.path('/ckiancupp');
        } else {
            const pnr: string | null = this.CommonsSessionStorageService.get('PNR');
            this.CommonsAncillariesService.getAncillarieSummary(undefined, null, pnr).then(CommonsAncillariesServiceSucces, CommonsAncillariesServiceError);
        }
    };

    public seatNotAvailableError = () => {
        this.ModalService.isNotWaiting();
        const modalObject = {
            title: {
                message: 'CKIANCPURC_MODAL_TARJ_TITLE',
                needsTranslate: true
            },
            needsTranslate: true,
            message: 'MODAL_UNAVAILABLE_SEATMAP',
            idModal: 'MOD_INFO_TITLE'
        };

        this.ModalService.showGenericModal(modalObject, true, null).result.then(this.UtilsService.goIbCose, this.UtilsService.goIbCose);
    };
}
